<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md10>
      <div class="display-1">Animals</div>
      <div class="text-xs-center">
        <v-progress-circular
          v-if="loading"
          :size="50"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>

      <vue-good-table
        ref="my-table"
        styleClass="vgt-table striped bordered"
        :max-height=this.height
        :fixed-header="true"
        :columns="columns"
        :rows="rows"
        @on-cell-click="onCellClick"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true
        }"
        :search-options="{
          enabled: true
        }">
        <div slot="table-actions">
          <account-group-icon />
          <v-btn
            small
            color="blue-grey"
            class="white--text"
            @click="buildEmail()"
            :disabled="!selected"
          >
            <account-group-icon />
            Upload
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
        </div>
        <div slot="table-actions-bottom">
          <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'name'">
            <v-avatar
              slot="activator"
              size="42px"
              color="indigo"
            >
              <img
                v-if="props.row.image"
                :src="props.row.picture"
                alt="Avatar"
              >
              <v-icon v-else color="white">person</v-icon>
            </v-avatar>
            <span style="font-weight: bold;">{{props.row.name}}</span>
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <v-avatar
              color="blue lighten-4"
              class="mr-2 mt-2"
              size="30"
              style="cursor: pointer;"
              @click="editItem(props)"
            >
              <v-icon small>edit</v-icon>
            </v-avatar>
            <v-avatar
              color="red lighten-4"
              class="mr-2 mt-2"
              size="30"
              style="cursor: pointer;"
              @click="deleteItemList(props)"
            >
              <v-icon small>delete</v-icon>
            </v-avatar>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </v-flex>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      @click="newItem()"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <EmailForm
      :visible="showEmailForm"
      :items="emailList"
      :selectedItems="emails"
      @close="closeThis"
    />

    <v-dialog v-model="dialog" max-width="500px" lazy>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md6 order-xs2 order-md1>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.name" v-on:keyup.enter="save" label="Name" ref="focusItem" prepend-icon='perm_identity'></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.diet" v-on:keyup.enter="save" label="Diet" prepend-icon='cake'></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.count" v-on:keyup.enter="save" label="Count" prepend-icon='looks_one'></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex xs12 md6 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <v-flex xs12 text-xs-center>
                  <croppa
                    v-model="croppa"
                    :initial-image="initialImage"
                    :placeholder-font-size="14"
                    :prevent-white-space="true"
                    :disable-drag-and-drop="false"
                    :width="180"
                    :height="180"
                    :zoom-speed="7"
                  >
                  </croppa>
                  <!-- <v-btn flat icon color="primary" small @click="croppa.moveUpwards(10)"><v-icon>arrow_upward</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.moveDownwards(10)"><v-icon>arrow_downward</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.moveLeftwards(10)"><v-icon>arrow_back</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.moveRightwards(10)"><v-icon>arrow_forward</v-icon></v-btn> -->
                  <v-btn flat icon color="primary" small @click="croppa.rotate(-1)"><v-icon>rotate_left</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.rotate()"><v-icon>rotate_right</v-icon></v-btn>
                  <!-- <v-btn flat icon color="primary" small @click="croppa.zoomIn()"><v-icon>zoom_in</v-icon></v-btn>
                  <v-btn flat icon color="primary" small @click="croppa.zoomOut()"><v-icon>zoom_out</v-icon></v-btn> -->
                  </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="red darken-1" flat @click.native="deleteItem">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewDialog" max-width="500px" lazy>
      <v-tabs
        color="blue"
        dark
      >
        <v-tabs-slider color="white"></v-tabs-slider>

        <v-tab href="#tab-1">
          Recents
        </v-tab>

        <v-tab href="#tab-2">
          Favorites
        </v-tab>

        <v-tab href="#tab-3">
          Nearby
        </v-tab>

        <v-tab-item :value="'tab-1'">
          <v-card>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 md6 order-xs2 order-md1>
                    <v-flex xs12>
                      <span class="headline">{{ editedItem.name }}</span><br />
                      <span class="subheading">({{ editedItem.diet }})</span>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 md6 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                    <img :src="editedItem.picture" height="150" v-if="editedItem.image"/>
                    <v-icon v-else x-large color="blue">person</v-icon>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tab-2'">
          <v-card>
            <v-card-text>Text 2</v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tab-3'">
          <v-card>
            <v-card-text>Text 3</v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>

    <v-dialog v-model="emailDialog" max-width="1000px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-flex xs12>
                  <span class="headline">Email</span><br />
                </v-flex>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-if="!editTo"
                  v-model="emailText"
                  label="To"
                  readonly
                  hint="Select to edit email addresses"
                  persistent-hint
                  @click.native="editTo = !editTo"
                ></v-text-field>
                <v-combobox
                  v-else
                  v-model="emails"
                  :items="emailList"
                  label="To"
                  chips
                  multiple
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      :selected="data.selected"
                      :disabled="data.disabled"
                      class="v-chip--select-multi"
                      close
                      @input="remove(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="cc"
                  :items="ccList"
                  label="Cc"
                  multiple
                  chips
                >
                  <template
                    slot="selection"
                    slot-scope="data"
                  >
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      :selected="data.selected"
                      :disabled="data.disabled"
                      class="v-chip--select-multi"
                      close
                      @input="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="bcc"
                  :items="bccList"
                  label="Bcc"
                  multiple
                  chips
                >
                  <template
                    slot="selection"
                    slot-scope="data"
                  >
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      :selected="data.selected"
                      :disabled="data.disabled"
                      class="v-chip--select-multi"
                      close
                      @input="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex xs12>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import VLazyImage from 'v-lazy-image'
import { VueGoodTable } from 'vue-good-table'
import imageExists from 'image-exists'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-croppa/dist/vue-croppa.css'
import EmailForm from './forms/EmailForm'

export default {
  components: {
    VueGoodTable,
    VLazyImage,
    EmailForm
  },
  data () {
    return {
      isAdmin: false,
      dialog: false,
      showEmailForm: false,
      croppa: {},
      initialImage: null,
      dataURL: '',
      viewDialog: false,
      emailDialog: false,
      loading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Diet',
          field: 'diet',
          thClass: 'hidden-sm-and-down',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Count',
          field: 'count',
          thClass: 'hidden-sm-and-down',
          tdClass: 'hidden-sm-and-down',
          type: 'number'
        },
        {
          label: 'Action',
          field: 'actions',
          sortable: false,
          hidden: false,
          html: true,
          width: '120px'
        }
      ],
      rows: [],
      exportFields: {
        'id': 'id',
        'Name': 'name',
        'Image': 'image',
        'Picture': 'picture',
        'Image File': 'imageFile',
        'Data Url': 'dataUrl',
        'Diet': 'diet',
        'Count': 'count'
      },
      editedItem: {
        id: 0,
        name: '',
        image: '',
        picture: '',
        imageFile: '',
        dataUrl: '',
        diet: '',
        count: 0
      },
      defaultItem: {
        id: 0,
        name: '',
        image: '',
        picture: '',
        imageFile: '',
        dataUrl: '',
        diet: '',
        count: 0
      },
      emails: [],
      cc: [],
      bcc: [],
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      editTo: false
    }
  },

  created () {
    this.loading = true

    if (this.$store.state.isAdmin) {
      this.isAdmin = true
    } else {
      this.isAdmin = this.$store.state.controls.includes('Users')
    }

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getAnimals()
    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    dialog (val) {
      this.$nextTick(this.$refs.focusItem.focus)
      val || this.close()
    }
  },

  methods: {
    pickFile () {
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files

      if (files[0] !== undefined) {
        this.editedItem.image = files[0].name

        if (this.editedItem.image.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])

        fr.addEventListener('load', () => {
          this.editedItem.picture = fr.result
          this.editedItem.imageFile = files[0]
        })
      } else {
        this.editedItem.image = ''
        this.editedItem.imageFile = ''
        this.editedItem.picture = ''
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    onCellClick (params) {
      if (params.column.field === 'name') {
        this.editedItem.name = params.row.name
        this.editedItem.diet = params.row.diet
        this.editedItem.count = params.row.count
        this.editedItem.image = params.row.image
        this.editedItem.picture = params.row.picture

        this.viewDialog = true
      }
      // params.row - row object
      // params.column - column object
      // params.rowIndex - index of this row on the current page.
      // params.event - click event
    },

    newItem () {
      let image = new Image()
      image.setAttribute('crossorigin', 'anonymous')
      image.src = ''

      this.initialImage = image
      this.croppa.refresh()

      this.dialog = true
    },

    editItem (props) {
      let image = new Image()
      image.setAttribute('crossorigin', 'anonymous')
      image.src = props.row.picture

      this.initialImage = image
      this.croppa.refresh()

      this.editedIndex = props.index
      this.editedItem.id = props.row.id
      this.editedItem.name = props.formattedRow.name
      this.editedItem.diet = props.formattedRow.diet
      this.editedItem.count = props.formattedRow.count
      this.editedItem.image = props.row.image
      this.editedItem.picture = props.row.picture
      this.dialog = true
    },

    save () {
      this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)
      // console.log(this.editedItem.dataUrl)

      if (this.editedIndex > -1) {
        // console.log('Update')
        this.updateItem(this.editedItem)
      } else {
        // console.log('Save')
        this.addItem(this.editedItem)
        this.rows.push(this.editedItem)
      }

      this.close()
    },

    deleteItem () {
      let r = confirm('Are you sure you want to delete ' + this.editedItem.name + '?')

      if (r === true) {
        this.rows.splice(this.editedIndex, 1)
        this.removeItem(this.editedItem.id)
      }

      this.close()
    },

    deleteItemList (props) {
      let r = confirm('Are you sure you want to delete ' + props.formattedRow.name + '?')

      if (r === true) {
        this.rows.splice(props.index, 1)
        this.removeItem(props.row.id)
      }
    },

    async getAnimals () {
      try {
        const response = await Api().get('animals')

        for (let item of response.data) {
          if (item.image) {
            imageExists(item.picture, (exists) => {
              if (!exists) {
                item.image = ''
                item.picture = ''
              }
            })
          }
        }

        this.rows = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async addItem (item) {
      try {
        const response = await Api().post('animals', item)
        this.editedItem.id = response.data.animal.id
        this.editedItem.image = response.data.animal.image
        this.editedItem.picture = response.data.animal.picture

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem (item) {
      try {
        const response = await Api().put('animals/' + item.id, item)
        this.editedItem.image = response.data.body.image
        this.editedItem.picture = response.data.animal.picture

        let newVal = Object.assign(this.rows[this.editedIndex], this.editedItem)
        this.$set(this.rows, this.editedIndex, newVal)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async removeItem (itemId) {
      try {
        const response = await Api().delete('animals/' + itemId)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    buildEmail () {
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].name + ' <' + this.rows[i].id + '>'
      }
      this.ccList = this.emailList
      this.bccList = this.emailList

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].name + ' <' + this.$refs['my-table'].selectedRows[i].id + '>'
      }

      // this.emails = this.$refs['my-table'].selectedRows
      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    remove (item) {
      console.log(item)
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.viewDialog = false
      this.emailDialog = false
      this.showEmailForm = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/Table3.vue